import BackToTop from '@unctad-infovis/general-tools/components/BackToTop.jsx';
import ChartDataWrapper from '@unctad-infovis/general-tools/components/ChartDataWrapper.jsx';
import Image from '@unctad-infovis/general-tools/components/Image.jsx';
import ProgressBar from '@unctad-infovis/general-tools/components/ProgressBar.jsx';
import Quote from '@unctad-infovis/general-tools/components/Quote.jsx';
import SideScrollingText from '@unctad-infovis/minisite-tools/components/SideScrollingText.jsx';

import { useEffect, useRef } from 'react';

import Article from '../Article.mdx';

// Specific
import ChartFDIExplorer from './components/ChartFDIExplorer.jsx';
import ChartFocusStrategic from './components/ChartFocusStrategic.jsx';

// Minisite
import Footer from './components/minisite/Footer.jsx';
import Header from './components/minisite/Header.jsx';
import HeaderChapter from './components/minisite/HeaderChapter.jsx';

import '@unctad-infovis/general-tools/styles/styles.css';
import './App.css';
import './components/minisite/minisite.css';

const components = {
  BackToTop,
  ChartDataWrapper,
  ChartFDIExplorer,
  ChartFocusStrategic,
  Footer,
  Header,
  HeaderChapter,
  Image,
  ProgressBar,
  Quote,
  SideScrollingText
};

const App = ({ meta }) => {
  const appRef = useRef();

  useEffect(() => {
    const elements = appRef.current.querySelectorAll('.container_chapter > p, .container_chapter > ul, .container_chapter > ol, .container_chapter > h3, .container_chapter > figure > blockquote, .container_chapter > .highlight_container');

    // Options for the observer (when the p tag is 50% in the viewport)
    const options = {
      threshold: 0.5 // Trigger when 50% of the paragraph is visible
    };

    // Callback function for when the intersection occurs
    const observerCallback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add the visible class when the element is in view
          entry.target.classList.add('visible');
        }
      });
    };

    // Create an IntersectionObserver instance with the callback and options
    const observer = new IntersectionObserver(observerCallback, options);

    // Observe each paragraph
    for (const el of elements) {
      observer.observe(el);
    }
    setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 500); // A short delay ensures the DOM is ready
  }, []);

  window.appRef = appRef;

  return (
    <div
      className="app"
      style={{
        '--main-color': 'var(--un-color-green-dark)',
        '--secondary-color': 'var(--un-color-green-text)'
      }}
      ref={appRef}
    >
      <Article components={components} meta={meta} />
    </div>
  );
};

export default App;
